import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, ComponentFactoryResolver, Inject, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject, Subscription } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { IssueTransactionStatus } from '../../../globals';
import { IIssueProviderService, IIssueTransactionProviderService, ISSUE_PROVIDER_SERVICE, ISSUE_TRANSACTION_PROVIDER_SERVICE, ISSUE_TYPE_PROVIDER_SERVICE, TRANSACTION_STEP_PROVIDER } from '../../../interfaces';
import { ISSUE_FORM_GROUP, Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';
import { IssueTransactionDialog2ComponentService } from './issue-transaction-dialog2-component-service';

@Component({
  selector: 'app-issue-transaction-dialog2',
  templateUrl: './issue-transaction-dialog2.component.html',
  styleUrls: ['./issue-transaction-dialog2.component.css'],
  providers: [
    { provide: TRANSACTION_STEP_PROVIDER, useClass: IssueTransactionDialog2ComponentService }
  ]
})
export class IssueTransactionDialog2Component implements OnDestroy, OnInit {

  // private fields
  private _dynamicInner = new ReplaySubject<ViewContainerRef>();
  private _currentIndex = new BehaviorSubject<number>(0);

  IssueTransactionStatus = IssueTransactionStatus;

  @ViewChild('dynamicInner', { static: true, read: ViewContainerRef }) set dynamicInner(ref: ViewContainerRef) {
    this._dynamicInner.next(ref);
  }
  @ViewChild(MatStepper) private stepper: MatStepper;

  title = 'Transaktion ausführen';

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) private issueService: IIssueProviderService,
    @Inject(ISSUE_TRANSACTION_PROVIDER_SERVICE) private _issueTransactionService: IIssueTransactionProviderService,
    @Inject(TRANSACTION_STEP_PROVIDER) public service: IssueTransactionDialog2ComponentService,
    private _ref: MatDialogRef<IssueTransactionDialog2Component>,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) { }

  close() {
    combineLatest([this.service.transactionStatus$, this.issueService.issue$, this.service.steps$])
      .pipe(take(1))
      .subscribe((result) => this._ref.close(result));
  }

  executeTransaction = () => this.lastStep().pipe(switchMap(() => this.service.executeTransaction())).toPromise();
  lastStep: () => Observable<Object> = () => this.service.steps$.pipe(take(1), tap((steps: Step[]) => this.stepper.selectedIndex = (steps.filter(x => !x.isHidden).length - 1)));

  loadInner(ref: ViewContainerRef, steps: Step[], index: number) {
    ref.clear();
    let step = steps.filter(x => !x.isHidden)[index];
    if (!step) return;
    let factory = this._componentFactoryResolver.resolveComponentFactory(step.view)
    ref.createComponent(factory, 0, Injector.create({
      providers: [
        { provide: 'step', useValue: step },
        { provide: ISSUE_TRANSACTION_PROVIDER_SERVICE, useValue: this._issueTransactionService },
        { provide: ISSUE_PROVIDER_SERVICE, useValue: this.issueService },
        { provide: STEP_FORM_GROUP, useValue: step.formGroup },
        { provide: ISSUE_FORM_GROUP, useValue: steps[0].formGroup },
        { provide: TRANSACTION_STEP_PROVIDER, useValue: this.service },
        { provide: ISSUE_TYPE_PROVIDER_SERVICE, useValue: this.issueService }
      ]
    }));
  }

  nextStep = () => this.stepper.next();

  ngOnDestroy(): void {
    this.service.dispose();
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueTransactionService.issueTransaction$.subscribe((transaction) => this.title = `Transaktion <span class='transaction-name'>${transaction.name}</span> ausführen`),
      combineLatest([
        this._dynamicInner,
        this.service.steps$,
        this._currentIndex
      ]).subscribe(([ref, steps, currentIndex]) => this.loadInner(ref, steps, currentIndex))
    ]);
  }

  previousStep = () => this.stepper.previous();
  stepperChanged = (event: StepperSelectionEvent) => this._currentIndex.next(event.selectedIndex);

}
